import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { CustomerContact } from '../lib/api.customer';

interface CustomerState {
  contact: CustomerContact | null;
  isLoading: boolean;
  /** ConnectWise Site-ID oder null = alle Standorte (Phase 2.11). */
  selectedCwSiteId: number | null;
  /**
   * Firmengruppe: Gesamtsicht über alle Gesellschaften, wo eine Seite sie kann (Verträge & Lizenzen,
   * Dashboard). Bewusst NICHT gespeichert — jede Sitzung beginnt mit „Alle Gesellschaften".
   */
  allCompaniesView: boolean;
  setAllCompaniesView: (value: boolean) => void;
  setContact: (contact: CustomerContact) => void;
  setLoading: (loading: boolean) => void;
  setSelectedCwSiteId: (id: number | null) => void;
  clear: () => void;
}

export const useCustomerStore = create<CustomerState>()(
  persist(
    (set) => ({
      contact: null,
      isLoading: false,
      selectedCwSiteId: null,
      allCompaniesView: true,
      setAllCompaniesView: (allCompaniesView) => set({ allCompaniesView }),
      setContact: (contact) => set((state) => {
        const validSiteIds = contact.portalLocationOptions?.map((o) => o.cwSiteId) ?? [];
        const keepSite = state.selectedCwSiteId !== null && validSiteIds.includes(state.selectedCwSiteId);
        return { contact, selectedCwSiteId: keepSite ? state.selectedCwSiteId : null };
      }),
      setLoading: (isLoading) => set({ isLoading }),
      setSelectedCwSiteId: (selectedCwSiteId) => set({ selectedCwSiteId }),
      clear: () => set({ contact: null, isLoading: false, selectedCwSiteId: null, allCompaniesView: true }),
    }),
    {
      name: 'customer-portal-session',
      partialize: (state) => ({
        contact: state.contact,
        isLoading: state.isLoading,
      }),
    }
  )
);
